import type { ElectricityPriceContext } from '../../types/siteEvidence';

const CONTEXT_KEYS = ['basis', 'sector', 'units', 'state', 'year'] as const;

/** Detach only a recognized EIA aggregate's metadata when a valid price is
 * actually adopted. Caller-owned document fields retain their own identity.
 * The old scalar remains scalar in providerValue; this receipt holds context. */
export function detachElectricityPriceContext(
  prior: Record<string, unknown> | null | undefined,
  adopted: Record<string, unknown>,
  source: string,
  value: unknown,
  suppliedFields: ReadonlySet<string> = new Set(),
): ElectricityPriceContext | undefined {
  if (!prior || typeof value !== 'number' || !Number.isFinite(value)
    || (prior.basis !== 'state-industrial-average'
      && !(/\beia\b/i.test(source) && (typeof prior.state === 'string' || typeof prior.year === 'number')))) return undefined;
  const context: ElectricityPriceContext = {};
  if (typeof prior.retailRate === 'number' && Number.isFinite(prior.retailRate)) context.retailRate = prior.retailRate;
  else if (prior.retailRate === null) context.retailRate = null;
  if (typeof prior.state === 'string') context.state = prior.state;
  if (typeof prior.year === 'number' && Number.isFinite(prior.year)) context.year = prior.year;
  if (prior.basis === 'state-industrial-average') context.basis = prior.basis;
  if (prior.sector === 'IND') context.sector = prior.sector;
  if (prior.units === 'cents per kilowatt-hour') context.units = prior.units;
  for (const key of CONTEXT_KEYS) {
    if (!suppliedFields.has(key)) delete adopted[key];
  }
  return context;
}
